import { CONVERSATION_STATE, CONVERSATION_TYPE, MessageConversation } from '../../models/messages/Messages'

export type ConversationV2Metadata = Partial<MessageConversation['conversation_attributes']> &
  Record<string, unknown> & {
    last_message_sent_datetime?: string | null
  }

export type ConversationV2 = {
  id: string
  external_conversation_id?: string | null
  type: CONVERSATION_TYPE
  status: CONVERSATION_STATE
  create_date_utc: string
  update_date_utc: string
  conversation_update_date?: string
  patient_id: string | null
  ai_coach_id: string | null
  provider_id?: string | null
  active_provider_ids?: string[]
  episode_id: string | null
  episode_ids?: string[]
  metadata: ConversationV2Metadata | null
}

/**
 * Normalizes a V2 LT conversation into the legacy shape consumed by the
 * member messaging UI.
 */
export const mapConversationV2ToMessageConversation = (conversation: ConversationV2): MessageConversation => {
  const { metadata } = conversation

  return {
    conversation_attributes: {
      ...metadata,
      episode_id: conversation.episode_id ?? undefined,
      last_patient_notification_sent: metadata?.last_patient_notification_sent ?? 0,
      last_provider_notification_sent: metadata?.last_provider_notification_sent ?? 0,
      type: conversation.type,
    },
    conversation_date_created: conversation.create_date_utc,
    conversation_id: conversation.id,
    db_conversation_id: conversation.id,
    episode_ids: conversation.episode_ids,
    patient_lyra_id: conversation.patient_id ?? '',
    provider_participant_status: conversation.status,
    provider_lyra_id: conversation.ai_coach_id ?? '',
    conversation_last_message_sent_datetime: metadata?.last_message_sent_datetime ?? null,
    conversation_update_datetime: conversation.update_date_utc,
    conversation_state: conversation.status,
  }
}
